export const SET_COUNTRY = (state, country) => {
    state.countryList = country;
}
